import React from "react";
import Header from "../../Sections/Header";
import Footer from "../../Sections/Footer";
import Price from "../../Sections/Price";
import NicheHero from "../../Components/NicheShared/NicheHero";
import NicheFeatures, { Feature } from "../../Components/NicheShared/NicheFeatures";
import NicheSteps from "../../Components/NicheShared/NicheSteps";
import NicheCTA from "../../Components/NicheShared/NicheCTA";
import NicheFollowUp from "../../Components/NicheShared/NicheFollowUp";
import RevealOnScroll from "../../Components/RevealOnScroll";
import { NavLink } from "../../types/nav";

const LINKS: NavLink[] = [
  { label: "Início",          to: "/restaurante#hero" },
  { label: "Funcionalidades", to: "/restaurante#features" },
  { label: "Como funciona",   to: "/restaurante#steps" },
  { label: "Planos",          to: "/restaurante#price" },
];

const FEATURES: Feature[] = [
  {
    icon: "mdi:silverware-fork-knife",
    title: "Cardápio interativo",
    description: "Cliente navega pelos pratos e escolhe direto no WhatsApp.",
  },
  {
    icon: "mdi:receipt-text-outline",
    title: "Pedidos automáticos",
    description: "Recebe, confirma e organiza pedidos sem intervenção da equipe.",
  },
  {
    icon: "mdi:table-chair",
    title: "Reservas de mesa",
    description: "Cliente reserva e recebe confirmação instantânea pelo chat.",
  },
  {
    icon: "mdi:message-text-outline",
    title: "Histórico de conversas",
    description: "Acompanhe pedidos e conversas de cada cliente em tempo real.",
  },
];

const STEPS: string[] = [
  "Cadastre seu cardápio e disponibilidade de mesas",
  "Cliente faz o pedido ou reserva pelo WhatsApp",
  "Alfred confirma e você só se preocupa em servir",
];

const Restaurante: React.FC = () => (
  <>
    <Header links={LINKS} />
    <NicheHero
      id="hero"
      headline={`Pedidos no WhatsApp, sem app de terceiro. <br/> O <span style="color:#E4DA1B;">Alfred</span> recebe tudo por você.`}
      subheadline="O Alfred apresenta seu cardápio, recebe pedidos e confirma cada um automaticamente."
    />
    <RevealOnScroll><NicheFeatures id="features" features={FEATURES} /></RevealOnScroll>
    <RevealOnScroll><NicheSteps id="steps" steps={STEPS} /></RevealOnScroll>
    <RevealOnScroll>
      <NicheFollowUp
        title="Clientes que não voltaram? O Alfred busca eles."
        subtitle="Sequências automáticas de follow-up para reativar clientes, pedir feedback e enviar ofertas exclusivas."
        items={[
          "Peça avaliação após a visita automaticamente",
          "Reative clientes que não voltam faz semanas",
          "Envie promoções de aniversário e datas especiais",
        ]}
      />
    </RevealOnScroll>
    <RevealOnScroll><NicheCTA phrase="Mais pedidos, zero comissão para aplicativo." /></RevealOnScroll>
    <div id="price">
      <Price />
    </div>
    <Footer />
  </>
);

export default Restaurante;
